import './gb-native-select.tag.html';
import './gb-custom-select.tag.html';
import { Select } from './gb-select';
riot.tag2('gb-select', '<yield> <gb-native-select if="{_config.native}"></gb-native-select> <gb-custom-select if="{!_config.native}"></gb-custom-select> </yield>', '', '', function(opts) {
    this._mixin(Select);
});



/** WEBPACK FOOTER **
 ** ./src/tags/select/gb-select.tag.html
 **/